import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'

import { FormGroup, FormControl, ControlLabel, Checkbox, HelpBlock, Glyphicon, Button, OverlayTrigger, Popover } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'

import { addUser } from '../../login/reducers/manageLogin'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

import NewUserCreatedModal from './NewUserCreatedModal'
import NewUserAlreadyExistsModal from './NewUserAlreadyExistsModal'


class AddUsers extends Component {
  state = {
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    department: "",
    title: "",
    isGenesisEmployee: false,
    isManager: false,
    notifyNewUser: true,
    selectedRole: [],
    selectedTeam: [],
    selectedClients: [],
    usernameIsValid: null,
    emailIsValid: null,
    showNewUserCreatedModal: false,
    savingUser: false,
    showNewUserAlreadyExistsModal: false,
    newUser: {},
    userWithMatchingField: {},
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })

  toggleIsGenesisEmployee = () => this.setState({ isGenesisEmployee: !this.state.isGenesisEmployee })

  toggleIsManager = () => this.setState({ isManager: !this.state.isManager })

  toggleNotifyUser = () => this.setState({ notifyNewUser: !this.state.notifyNewUser })

  getUsernameValidationState = () => {
    const { username, usernameIsValid } = this.state
    if (username && usernameIsValid === false) {
      return 'error'
    } else if (username && usernameIsValid === true) {
      return 'success'
    } else {
      return null
    }
  }

  getEmailValidationState = () => {
    const { email, emailIsValid } = this.state

    // eslint-disable-next-line
    const emailFormatChecker = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    const emailFormatIsValid = emailFormatChecker.test(String(email).toLowerCase())

    if (email && !emailFormatIsValid) {
      return 'error'
    } else if (email && emailIsValid === false) {
      return 'error'
    } else if (email && emailIsValid === true) {
      return 'success'
    } else {
      return null
    }
  }

  verifyData = (stateKey, boolean, route) => {
    const stateElement = this.state[stateKey]

    if (!stateElement) {
      return
    }

    axios({
      method:"GET",
      url:`${getServerURL()}${route}/`,
      headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
      params: { [stateKey]: stateElement }
    })
    .then(response => {
      return this.setState({ [boolean]: true })
    })
    .catch(error => {
      if (error.response && error.response.status && error.response.status === 409) {
        return this.setState({
          showNewUserAlreadyExistsModal: true,
          userWithMatchingField: error.response.data.user,
          [boolean]: false,
        })
      }
    })
  }


  createUser = () => {
    const { firstName, lastName, username, email, department, title, isGenesisEmployee, isManager, notifyNewUser, selectedClients, selectedRole, selectedTeam, usernameIsValid, emailIsValid } = this.state

    let message = ''

    if (!firstName || !lastName || !username || !email) {
      message = "Please fill out all required fields"
    } else if ((!usernameIsValid || !username) && (!emailIsValid || !email)) {
      message = 'Username and email are not valid'
    } else if (!usernameIsValid || !username) {
      message = 'Username is not valid'
    } else if (!emailIsValid || !email) {
      message = 'Email is not valid'
    }

    if (message) {
      return swal({
        title: "Error",
        text: message,
        icon: "error",
        button: "Continue",
      })
    }

    this.setState({ showNewUserCreatedModal: true, savingUser: true })

    let role, team
    if (selectedRole && selectedRole[0]) {
      role = selectedRole[0].url
    }

    if (selectedTeam && selectedTeam[0]) {
      team = selectedTeam[0].url
    }

    axios({
      method:"POST",
      url:`${getServerURL()}users/`,
      headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
      data: {
        first_name: firstName,
        last_name: lastName,
        username,
        email,
        department,
        title,
        role,
        team,
        genesis_employee: isGenesisEmployee,
        is_manager: isManager,
        clients: selectedClients.map(client => client.url),
        notify_new_user: notifyNewUser,
      }
    })
    .then(response => {
      this.props.addUser(response.data)
      this.setState({
        firstName: "",
        lastName: "",
        username: "",
        email: "",
        department: "",
        title: "",
        isGenesisEmployee: false,
        isManager: false,
        notifyNewUser: true,
        selectedClients: [],
        selectedRole: [],
        selectedTeam: [],
        usernameIsValid: null,
        emailIsValid: null,
        newUser: response.data,
        savingUser: false
      })
    })
    .catch(error => {
      this.setState({ savingUser: false })
      let message
      if (error.response && error.response.data && error.response.data.detail) {
        message = error.response.data.detail
      } else {
        message = "There was an error creating the user"
      }
      return handleErrorFetchingData(error, message)
    })
  }

  toggleNewUserCreatedModal = () => this.setState({ showNewUserCreatedModal: !this.state.showNewUserCreatedModal})

  hideNewUserAlreadyExistsModal = () => {
    this.setState({
      showNewUserAlreadyExistsModal: !this.state.showNewUserAlreadyExistsModal,
      userWithMatchingField: {},
    })
  }


  render() {
    const { firstName, lastName, username, email, /* department, title, */isGenesisEmployee, isManager, notifyNewUser, selectedClients, selectedRole, selectedTeam } = this.state

    const filteredClients = this.props.clients.filter(client => client.subdomain !== 'genesis')
    .sort((a, b) => {
      return `${a.name} ${a.short_code}`.localeCompare(`${b.name} ${b.short_code}`)
    })

    const managerInfoPopover = (
      <Popover id='manager-info-popover' title="Manager">
        Managers can create, edit, and delete projects, proposals, metadata, etc., and can view analytics data.
      </Popover>
    )

    const notifyNewUserPopover = (
      <Popover id='notify-new-user-popover' title="Notify New User?">
        If checked, the new user will receive an email with their username and an auto-generated temporary password.
      </Popover>
    )

    return (
      <div id="AddUsers">

        <NewUserCreatedModal
          show={this.state.showNewUserCreatedModal}
          handleClose={this.toggleNewUserCreatedModal}
          newUser={this.state.newUser}
          savingUser={this.state.savingUser}
        />

        <NewUserAlreadyExistsModal
          show={this.state.showNewUserAlreadyExistsModal}
          handleClose={this.hideNewUserAlreadyExistsModal}
          user={this.state.userWithMatchingField}
        />

        <p>
          Required fields are denoted with <span className="required">*</span>
        </p>

        <FormGroup>
          <ControlLabel>
            First Name <span className="required">*</span>
          </ControlLabel>
          <FormControl
            type="text"
            name="firstName"
            value={firstName}
            onChange={this.handleChange}
          >
          </FormControl>
        </FormGroup>

        <FormGroup>
          <ControlLabel>
            Last Name <span className="required">*</span>
          </ControlLabel>
          <FormControl
            type="text"
            name="lastName"
            value={lastName}
            onChange={this.handleChange}
          >
          </FormControl>
        </FormGroup>

        <FormGroup validationState={this.getUsernameValidationState()}>
          <ControlLabel>
            Username <span className="required">*</span>
          </ControlLabel>
          <FormControl
            type="text"
            name="username"
            value={username}
            onChange={this.handleChange}
            onBlur={() => this.verifyData('username', 'usernameIsValid', 'verify-username')}
          >
          </FormControl>
          <FormControl.Feedback />
        </FormGroup>

        <FormGroup validationState={this.getEmailValidationState()}>
          <ControlLabel>
            Email <span className="required">*</span>
          </ControlLabel>
          <FormControl
            type="text"
            name="email"
            value={email}
            onChange={this.handleChange}
            onBlur={() => this.verifyData('email', 'emailIsValid', 'verify-user-email')}
          >
          </FormControl>
          <FormControl.Feedback />
        </FormGroup>

        <FormGroup>
          <ControlLabel>
            Role
          </ControlLabel>
          <Typeahead
            id='RoleSelectTypeahead'
            clearButton
            labelKey={(option) => option.name}
            options={this.props.roles}
            selected={selectedRole}
            onChange={(selectedRole) => this.setState({ selectedRole })}
            placeholder="Select role"
          />
        </FormGroup>

        <FormGroup>
          <ControlLabel>
            Team
          </ControlLabel>
          <Typeahead
            id='TeamSelectTypeahead'
            clearButton
            labelKey={(option) => {
              if (option.subgroup) {
                return `${option.name} - ${option.subgroup}`
              }
              return option.name
            }}
            options={this.props.teams}
            selected={selectedTeam}
            onChange={(selectedTeam) => this.setState({ selectedTeam })}
            placeholder="Select team"
          />
        </FormGroup>

        {/* <FormGroup>
          <ControlLabel>
            Department
          </ControlLabel>
          <FormControl
            type="text"
            name="department"
            value={department}
            onChange={this.handleChange}
          >
          </FormControl>
        </FormGroup>

        <FormGroup>
          <ControlLabel>
            Title
          </ControlLabel>
          <FormControl
            type="text"
            name="title"
            value={title}
            onChange={this.handleChange}
          >
          </FormControl>
        </FormGroup> */}

        <Checkbox
          id="isGenesisEmployeeCheckbox"
          name='isGenesisEmployee'
          checked={isGenesisEmployee}
          onChange={this.toggleIsGenesisEmployee}
        >
          <strong>
            Is this user a Genesis Research employee?
          </strong>
        </Checkbox>

        <Checkbox
          id="isManagerCheckbox"
          name='isManager'
          checked={isManager}
          onChange={this.toggleIsManager}
        >
          <strong>
            Is this user a manager?
          </strong> &nbsp;
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement="right"
            overlay={managerInfoPopover}
          >
            <Glyphicon glyph='info-sign' />
          </OverlayTrigger>
        </Checkbox>

        <Checkbox
          id="notifyNewUserCheckbox"
          name='notifyNewUser'
          checked={notifyNewUser}
          onChange={this.toggleNotifyUser}
        >
          <strong>
            Send email notification to new user?
          </strong> &nbsp;
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement="right"
            overlay={notifyNewUserPopover}
          >
            <Glyphicon glyph='info-sign' />
          </OverlayTrigger>
        </Checkbox>

        <FormGroup>
          <ControlLabel>
            Select Clients
          </ControlLabel>
          <Typeahead
            id='ClientSelectTypeahead'
            multiple
            labelKey={client => `${client.name} ${client.short_code}`}
            options={filteredClients}
            selected={selectedClients}
            onChange={(selectedClients) => this.setState({ selectedClients })}
            placeholder="Select clients"
          />
          <HelpBlock>
            Select Clients if user will need access to any client-facing PTORs
          </HelpBlock>
        </FormGroup>

        <Button
          bsStyle="primary"
          onClick={this.createUser}
        >
          Create User
        </Button>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.manageLogin.users,
    clients: state.manageLogin.clients,
    roles: state.manageLogin.roles,
    teams: state.manageLogin.teams,
  }
}

export default connect(mapStateToProps, { addUser })(AddUsers)



// WEBPACK FOOTER //
// ./src/routes/manager/components/AddUsers.js